import { makeStyles } from '@lifeomic/chroma-react/styles';
import React from 'react';

const useStyles = makeStyles(theme => ({
  root: {
    background: theme.palette.primary.main,
    borderRadius: theme.pxToRem(3),
    color: theme.palette.common.white,
    display: 'inline-block',
    fontSize: theme.pxToRem(12),
    minWidth: theme.pxToRem(18),
    margin: theme.spacing(0, -0.75, 0, 0.75),
    padding: theme.spacing(0.125, 1),
    position: 'relative',
    [theme.breakpoints.down('lg')]: {
      display: 'inline',
    },
  },
}));

interface SequenceDetailsBadgeProps {
  value?: string;
}

export const SequenceDetailsBadge: React.FC<SequenceDetailsBadgeProps> = ({
  value,
  ...rootProps
}) => {
  const classes = useStyles({});
  return (
    <span className={classes.root} {...rootProps}>
      {value}
    </span>
  );
};
